<div class="simplified-container">
  <div class="flex justify-center">
    <div class="account-container">
      <div class="flex payment">
        <form [formGroup]="accountSelectionFormGroup">
          <div class="payment-account">
            <!-- Account and payment selection -->
            <div class="flex subheading">
              <div class="plusSign" data-cy="accountSelectionStepOne">{{ 1 }}</div>
              <span
                data-cy="selectionSubHeading"
                class="textHeading"
                dsContent
                [contentPath]="'billing.phoenixPayment.selectionSubHeading'"
              ></span>
            </div>
            <div>
              <amfam-simplified-payment-checkbox
                [controlName]="'option'"
                [parentFormGroup]="accountSelectionFormGroup"
                [billAccountOptions]="billAccountOptionFiltered"
              ></amfam-simplified-payment-checkbox>
            </div>
          </div>
        </form>
        <div class="paymentDateWrapper">
          <span
            class="paymentDate"
            dsContent
            [contentPath]="'billing.phoenixPayment.paymentDate'"
          ></span>
          <span style="margin-left: 8px">{{
            this.paymentDateValue | dateFormat: 'MMM DD, YYYY'
          }}</span>
        </div>
        <div class="flex subheading" style="margin-top: 24px">
          <div class="plusSign" data-cy="accountSelectionStepOne">{{ 2 }}</div>
          <h3
            data-cy="paymentMethod"
            dsContent
            [contentPath]="'billing.phoenixPayment.paymentMethod'"
          ></h3>
        </div>
        <div class="flex subheading" style="margin-top: 24px">
          <ds-we-accept [isHomesite]="false" />
        </div>
        <div class="flex subheading" style="margin-top: 24px">
          Iframe will be added here and submit button removed
          <button (click)="submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>
